module.exports = __webpack_public_path__ + "static/media/code.e70dd030.png";